import { Card } from "react-bootstrap";
import { GiMove } from "react-icons/gi";
import { BiLinkExternal } from "react-icons/bi";
// @ts-ignore
import Fade from 'react-reveal/Fade';
// import ApexChart from "react-apexcharts";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import BarChart from "./BarChart";
import LineChart from "./LineChart";
import AreaChart from "./AreaChart";
import PieChart from "./PieChart";
import { useAppSelector } from "@/Hook/hooks";
import { IObjects } from "@/Redux/Ducks/dashboardSlice";

const renderChart = ({ chartType, ...restProps }: any) => {
  if (chartType.isEqual("BAR", "COL")) {
    return (
      <BarChart {...restProps} />
    )
  }
  else if (chartType.isEqual("LNE")) {
    return (
      <LineChart {...restProps} />
    )
  }
  else if (chartType.isEqual("ARA")) {
    return (
      <AreaChart {...restProps} />
    )
  }
  else if (chartType.isEqual("PIE", "DNT")) {
    return (
      <PieChart {...restProps} type={chartType.isEqual("PIE") ? "pie" : "donut"} />
    )
  }
  else
    return null;
}

interface IProps {
  widgetno: string;
}

const Chart = ({ widgetno }: IProps) => {
  const widget = useAppSelector(x => x.Dashboard.activeWidget.objects.find(x => x.widgetno == widgetno)) as IObjects;

  return (
    <div className="chart-card">
      <Fade>
        <Card>
          <Card.Header>
            {widget.widgetstxt}

            {
              widget.widgetprocesscode ? (
                <OverlayTrigger placement="bottom" overlay={<Tooltip>Hyperlink</Tooltip>}>
                  <div className="hyperlink" onClick={() => { }}>
                    <BiLinkExternal size={16} />
                  </div>
                </OverlayTrigger>
              ) : null
            }

            <OverlayTrigger placement="bottom" overlay={<Tooltip>Move</Tooltip>}>
              <div className="drag-handle">
                <GiMove size={16} />
              </div>
            </OverlayTrigger>
          </Card.Header>
          <Card.Body>
            <div style={{ height: "100%", padding: "10px 16px" }}>
              {
                renderChart({ chartType: widget.widgetcontroltype, data: widget.data, columns: widget.columns })
              }
            </div>
          </Card.Body>
        </Card>
      </Fade>
    </div>
  )
};

export default Chart;
